import { render, staticRenderFns } from "./ContratacoesDash.vue?vue&type=template&id=555c50f6"
import script from "./ContratacoesDash.vue?vue&type=script&lang=js"
export * from "./ContratacoesDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports